class AjaxPosts {
  constructor(el, opt) {
    this.el = el;
  }

  getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  postChange(postType, postsPerPage) {
    const targetElement = '.js-ajax-posts';
    const thisUrl = new URL(location.href);
    const pCat = this.getParam('p-cat', thisUrl);
    const pDate = this.getParam('p-date', thisUrl);
    const startDate = this.getParam('start-date', thisUrl);
    const endtDate = this.getParam('end-date', thisUrl);
    const paged = this.getParam('paged', thisUrl);
    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        'action': 'fetch_posts',
        'post_type': postType,
        'posts_per_page': postsPerPage,
        'p_cat': pCat,
        'p_date': pDate,
        'start_date': startDate,
        'end_date': endtDate,
        'paged': paged
      },
    })
      .done(function (data) {

        $(targetElement).html(data)

      })
      .fail(function () {

      });
  }

  paginationChange(postType, postsPerPage) {
    const targetElement = '.js-ajax-pagination';
    const thisUrl = new URL(location.href);
    const pCat = this.getParam('p-cat', thisUrl);
    const pDate = this.getParam('p-date', thisUrl);
    const paged = this.getParam('paged', thisUrl);
    const startDate = this.getParam('start-date', thisUrl);
    const endtDate = this.getParam('end-date', thisUrl);
    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        'action': 'fetch_pagination',
        'post_type': postType,
        'posts_per_page': postsPerPage,
        'p_cat': pCat,
        'p_date': pDate,
        'this_url': thisUrl.href,
        'paged': paged,
        'start_date': startDate,
        'end_date': endtDate,
      },
    })
      .done(function (data) {

        $(targetElement).html(data);

        const targetWrap = document.getElementById('ajax-posts-wrap');
        if (targetWrap) {
          targetWrap.scrollIntoView({ behavior: 'smooth' }); // スムーズスクロール
        }
      })
      .fail(function (data) {
        console.log(data.responseText)
      });
  }

  doPagination(element, postType, postsNum) {

    const thisUrl = new URL(location.href);
    const paged = 'paged=' + element.dataset.paged;
    const thisPaged = this.getParam('paged', thisUrl);
    if (thisPaged) {
      // thisUrlがURLオブジェクトであると仮定
      const params = new URLSearchParams(thisUrl.search);
      // パラメータを更新
      params.set('paged', element.dataset.paged);
      // 更新したクエリ文字列をURLに再設定
      thisUrl.search = params.toString();
      history.pushState('記事検索', '検索', thisUrl.href);
    }
    else if (thisUrl.search) {
      history.pushState('記事検索', '検索', thisUrl.href + '&' + paged);
    } else {
      history.pushState('記事検索', '検索', thisUrl.href + '?' + paged);
    }

    this.postChange(postType, postsNum);
    this.paginationChange(postType, postsNum);
  }
}